import type { ContentKind } from "./content-kinds"

export const BASE_ITEMS = [
  {
    id: "templates",
    name: "Templates",
  },
  {
    id: "customize",
    name: "Customize",
  },
  {
    id: "elements",
    name: "Elements",
  },
  {
    id: "images",
    name: "Images",
  },
  {
    id: "uploads",
    name: "Uploads",
  },
  {
    id: "text",
    name: "Text",
  },
  {
    id: "graphics",
    name: "Graphics",
  },

  {
    id: "pixabay",
    name: "Pixabay",
  },
  {
    id: "layers",
    name: "Layers",
  },
  {
    id: "animations",
    name: "Animations",
  },
]

/**
 * Base estática: canvas sem tempo, sem vídeo e sem animação.
 * Vale para Digital e Impresso.
 */
export const STATIC_PANEL_ITEMS = BASE_ITEMS.filter((item) => item.id !== "animations" && item.id !== "videos")

// Mantido por compatibilidade com imports existentes.
export const GRAPHIC_PANEL_ITEMS = STATIC_PANEL_ITEMS

/**
 * Material digital (imagem estática): sem animação, sem vídeo.
 */
export const DIGITAL_PANEL_ITEMS = STATIC_PANEL_ITEMS

/**
 * Impresso: mesmas ferramentas do digital. Sangria, área segura e medidas em
 * mm entram como propriedades do documento, não como painéis.
 */
export const PRINT_PANEL_ITEMS = STATIC_PANEL_ITEMS

/**
 * Apresentação tem várias páginas e permite animação, mas não tem vídeo,
 * áudio nem timeline.
 */
export const PRESENTATION_PANEL_ITEMS = BASE_ITEMS.filter((item) => item.id !== "videos")

/**
 * Vídeo é o único tipo com tempo, áudio, vídeo e animação.
 */
export const VIDEO_PANEL_ITEMS = [
  {
    id: "templates",
    name: "Templates",
  },
  {
    id: "customize",
    name: "Customize",
  },
  {
    id: "elements",
    name: "Elements",
  },
  {
    id: "images",
    name: "Images",
  },
  {
    id: "videos",
    name: "Videos",
  },
  {
    id: "uploads",
    name: "Uploads",
  },
  {
    id: "text",
    name: "Text",
  },
  {
    id: "graphics",
    name: "Graphics",
  },

  {
    id: "pixabay",
    name: "Pixabay",
  },
  {
    id: "layers",
    name: "Layers",
  },
  {
    id: "animations",
    name: "Animations",
  },
]

export const panelsForKind = (kind: ContentKind) => {
  if (kind === "VIDEO") return VIDEO_PANEL_ITEMS
  if (kind === "PRESENTATION") return PRESENTATION_PANEL_ITEMS
  if (kind === "PRINT") return PRINT_PANEL_ITEMS
  return DIGITAL_PANEL_ITEMS
}

export enum PanelType {
  TEMPLATES = "Templates",
  BACKGROUND = "Background",
}
